module.exports = "/static/fonts/OpenSans-Semibold.eot";